
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import TextButton from '@/components/shared/suites/TextButton.vue';
import TextField from '@/components/shared/TextField.vue';

const namespace: string = 'orders';

@Component<PromoCode>({
	components: {
		TextField,
		TextButton
	}
})
export default class PromoCode extends Vue {
	@Action('validateDiscount', { namespace }) private validateDiscount!: (payload: { discountCode: string }) => Promise<void>;
	@Getter('getDiscountInfo', { namespace }) private promoDiscountInfo!: CostsDiscount | null;
	@Prop({ type: Boolean, default: false }) private disabled!: boolean;

	private discountCode: string = '';
	private successMsg: string = '';
	private errorMsg: string = '';
	private loading: boolean = false;

	private created(): void {
		if (this.disabled) {
			this.successMsg = this.$t('orders.guest_details.discount.manual_discount_applied', { discountPercentage: this.promoDiscountInfo?.percentageValue || 0 });
		}
		else if (this.promoDiscountInfo?.code) {
			this.discountCode = this.promoDiscountInfo.code;
			this.successMsg = this.$t('orders.guest_details.discount.discount_applied');
		}
	}

	/**
	 * Check the code and apply the promo
	 *
	 * @return {Promise<void>}
	 */
	private async applyDiscount(): Promise<void> {
		this.loading = true;
		this.errorMsg = '';
		this.successMsg = '';
		try {
			await this.validateDiscount({ discountCode: this.discountCode });
			this.loading = false;
			this.successMsg = this.$t('orders.guest_details.discount.discount_applied');
		}
		catch {
			this.loading = false;
			this.errorMsg = this.$t('orders.guest_details.discount.discount_not_applied');
		}
	}
}
